var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scope-of-application"},[_c('div',{staticClass:"block-content"},[_c('block-title',{attrs:{"en":_vm.section.title.en,"title":_vm.section.title.value,"sub":_vm.section.title.sub}})],1),_vm._v(" "),_c('case-list',{attrs:{"list":_vm.section.list}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }